<script lang="ts" setup>
import type { ComponentBlockBlogImageFragment } from "~~/types/graphql";

const props = defineProps<{
  BlogImage: ComponentBlockBlogImageFragment["BlogImage"];
  BlogImageEagerLoading: ComponentBlockBlogImageFragment["BlogImageEagerLoading"];
  BlogImageFetchPriority: ComponentBlockBlogImageFragment["BlogImageFetchPriority"];
}>();
</script>

<template>
  <div class="blog-image">
    <base-image
      v-bind="props.BlogImage.data?.attributes"
      sizes="(min-width: 720px) 42rem, (max-width: 719px) 100vw"
      :eager-loading="props.BlogImageEagerLoading ? true : false"
      :fetch-priority="props.BlogImageFetchPriority ? true : false"
    />
  </div>
</template>
